{
  "navigation": {
    "dashboard": "الرئيسية",
    "operations": "العمليات"
  },
  "sidebar": {
    "title": "القائمة الجانبية",
    "description": "قائمة التنقل",
    "toggleHint": "تبديل التنقل (Ctrl/Cmd+B)",
    "toggle": "تبديل القائمة الجانبية"
  },
  "user": {
    "notifications": "الإشعارات",
    "systems": "الأنظمة",
    "lightTheme": "الوضع الفاتح",
    "darkTheme": "الوضع الداكن"
  },
  "documentTitle": "المحروقات - العمليات",
  "nav": {
    "changeBranch": "تغيير الفرع",
    "systems": "الأنظمة"
  }
}
